/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum MetadataState {
    AIRING_ERROR,
    AIRING_READY,
    PREPARING,
    PREVIEW_ERROR,
    PREVIEW_READY,
    VOD_PREVIEW_ERROR,
    VOD_PREVIEW_READY,
}
